import React from "react";

import Cube from "../../assets/gif/cube.gif";
import Sphere from "../../components/Sphere";

function Intro() {
  return (
    <div className="w-screen h-screen text-white">
      <Sphere className="" />
      <div className="flex flex-col justify-center items-center h-full md:h-[90%]">
        <div className="w-full h-full flex flex-col md:flex-row justify-center items-center gap-0">
          <div className="text-center md:text-right w-[80vw] md:w-[18%] text-xl md:text-[24px] font-bold">
            Solutions that empower you on your Web3 journey.
          </div>
          <div className="w-[90vw] md:w-[38%] flex justify-center items-center md:mt-0">
            <img src={Cube} alt="cube" className="mix-blend-screen" />
          </div>
          <div className="md:mt-0 text-left w-[80vw] md:w-[18%] text-center md:text-right text-xl md:text-[24px] font-bold">
            Creating a comprehensive decentralized experience.
          </div>
        </div>

        {/* Contact us button */}
        <a
          href="https://r9c7781s650.typeform.com/to/QHP2tHQJ"
          target="_blank"
          className="relative -top-[10%] md:-top-28 uppercase px-3 py-2 rounded-[50px] bg-gradient-to-b from-[#A2C7FF] to-[#7472D1] hover:bg-gradient-to-b hover:from-[#C9DFFF] hover:to-[#A19FFF] hover:drop-shadow-lg hover:shadow-[#fff]"
          rel="noreferrer"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
}

export default Intro;
